import { Dispatch, SetStateAction } from "react";
import { AppDispatch } from "@portal/redux/store";
import { IBankAccount } from "@portal/types/api/IBankAccount";
import { IPortfolio } from "@portal/types/api/IPortfolio";
import { setSavingsAgreementPortfolioId, setSavingsAgreementCashAccount } from "@portal/redux/reducers/ui/createSavingsAgreement";

/**
 * Component to handle account selection in the savings robot.
 * The component separates between a cash account and a portfolio (savings account).
 * It also handles the option of creating a new ASK portfolio.
 * @param account
 * @param dispatch
 */
export const OnAccountChange = (
  account: IBankAccount | IPortfolio,
  dispatch: AppDispatch,
  setShowCreateAskModal: Dispatch<SetStateAction<boolean>>,
) => {
  if (IsAccount(account)) {
    dispatch(setSavingsAgreementCashAccount(account.accountNumber));
    return;
  }

  if (IsNewAskAccout(account)) {
    setShowCreateAskModal(true);
    return;
  }

  dispatch(setSavingsAgreementPortfolioId(account.portfolioId));
};

function IsAccount(obj: IBankAccount | IPortfolio): obj is IBankAccount {
  return "accountNumber" in obj;
}

function IsNewAskAccout(portfolio: IPortfolio) {
  return portfolio.portfolioId === "0";
}
